<template>
        <i class="mdi mdi-shopping"></i>
</template>

<script>
    export default {
        name: 'ShopIcon'
    }
</script>

<style>

</style>